import { render, staticRenderFns } from "./bidManagement.vue?vue&type=template&id=174c1056&scoped=true&"
import script from "./bidManagement.vue?vue&type=script&lang=js&"
export * from "./bidManagement.vue?vue&type=script&lang=js&"
import style0 from "./bidManagement.vue?vue&type=style&index=0&id=174c1056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c1056",
  null
  
)

export default component.exports